import { Breadcrumb, For } from '@chakra-ui/react'
import sortBy from 'lodash/sortBy'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import useGetObjectsByIds from '@app/hooks/useGetObjectsByIds'
import type { BusinessContextQuery } from '@graphql/queries'

const BusinessContextBreadcrumbBuilder = ({ businessContext }) => (
  <>
    <Breadcrumb.Separator />
    <Breadcrumb.Item>
      <Breadcrumb.Link asChild>
        <Link to={`/maps/${businessContext.slug}`}>{businessContext.name}</Link>
      </Breadcrumb.Link>
    </Breadcrumb.Item>
  </>
)

interface Props {
  businessContext: BusinessContextQuery['businessContext']
  loading?: boolean
  lastCrumbTitle?: string
  lastCrumbLink?: string
}

const ContextBreadcrumbs: FC<Props> = ({
  businessContext,
  lastCrumbTitle = null,
  lastCrumbLink = null,
  loading = false
}) => {
  // const businessContext = useGetObjectsByProperties('businessContext', { slug: businessContextId })[0]
  const parentBusinessContextsIds = businessContext?.parentBusinessContexts?.map((pbc) => pbc.id) || []
  const parentBusinessContexts = useGetObjectsByIds('businessContext', parentBusinessContextsIds)

  // This is the quick way to do it. If we allow re-parenting of any sort this logic will not work, and we'll have
  // to instead walk through each one to rebuild the tree branch.
  const sortedParentBusinessContexts = sortBy(parentBusinessContexts, 'id')

  let selfBreadcrumb = null
  let lastCrumb = null

  if (loading) {
    return null
  }

  if (businessContext) {
    selfBreadcrumb = <BusinessContextBreadcrumbBuilder businessContext={businessContext} />
  }

  if (lastCrumbTitle) {
    lastCrumb = (
      <>
        <Breadcrumb.Separator />
        <Breadcrumb.Item>
          <Breadcrumb.Link asChild>
            <Link to={lastCrumbLink}>{lastCrumbTitle}</Link>
          </Breadcrumb.Link>
        </Breadcrumb.Item>
      </>
    )
  }

  return (
    <Breadcrumb.Root size="md">
      <Breadcrumb.List>
        <Breadcrumb.Item>
          <Breadcrumb.Link asChild>
            <Link to="/maps">Maps</Link>
          </Breadcrumb.Link>
        </Breadcrumb.Item>
        <For each={sortedParentBusinessContexts}>
          {(parentBusinessContext) => (
            <BusinessContextBreadcrumbBuilder key={parentBusinessContext.id} businessContext={parentBusinessContext} />
          )}
        </For>
        {selfBreadcrumb}
        {lastCrumb}
      </Breadcrumb.List>
    </Breadcrumb.Root>
  )
}

export default ContextBreadcrumbs
